/*
---
covers:
  - frontend/src/pages/empresa/mi_espacio/mi-perfil-sociodemografico.tsx
  - frontend/src/components/perfil-sociodemografico-card.tsx
  - frontend/src/components/perfil-sociodemografico-consent.tsx
  - frontend/src/components/perfil-sociodemografico-laboral-step.tsx
  - frontend/src/components/perfil-sociodemografico-personal-step.tsx
  - frontend/src/components/perfil-sociodemografico-salud-step.tsx
  - frontend/src/hooks/empresa/mi_espacio/use-perfil-sociodemografico.ts
  - backend/app/salud/perfil_riesgo/routers/perfil.py
revisado: 2026-09-28
---
*/
import type {ManualSeccion} from '../types'

export const seccion: ManualSeccion = {
  id: 'tu-perfil-sociodemografico',
  titulo: 'Tu perfil sociodemográfico',
  resumen:
    'El cuestionario que exige la Resolución 0312/2019, con un tier de datos sensibles de salud que solo tú puedes ver — tu empresa solo ve estadísticas anónimas del conjunto.',
  enCorto: [
    'El cuestionario que exige la Resolución 0312',
    'Acepte el tratamiento y conteste tres pasos',
    'Su empresa solo ve estadísticas del conjunto',
  ],
  replayId: 'tu-perfil-sociodemografico',
  operaciones: [
    {
      id: 'aceptar-tratamiento-datos',
      titulo: 'Aceptar el tratamiento de tus datos antes de empezar',
      como: 'Llegas acá de dos maneras: el asistente del registro te trae al terminar tus preguntas de riesgos, o Kairos te lo pide al entrar si te quedó pendiente. También lo abres cuando quieras desde la pestaña «Sociodemográfico» de «Mi información». Lo primero que ves es el texto de autorización de tratamiento de datos (Ley 1581); aceptarlo desbloquea el resto del cuestionario.',
      porQueImporta:
        'Esta ficha incluye datos sensibles de salud (enfermedades, consumo de sustancias) — Kairos nunca los captura sin tu autorización explícita, y ningún campo del formulario existe para ti antes de que aceptes.',
    },
    {
      id: 'llenar-los-tres-pasos',
      titulo: 'Llenar los tres pasos del cuestionario',
      como: 'El formulario avanza en 3 pasos (el indicador arriba muestra «Página X de 3»): datos laborales, información familiar y de vivienda, y hábitos de salud. Cada respuesta se guarda sola al cambiar de campo — el botón «Siguiente» solo te mueve de paso.',
      porQueImporta:
        'Como se guarda automáticamente, puedes cerrar la sesión a la mitad y retomar exactamente donde ibas — Kairos recuerda el último paso al que llegaste.',
    },
    {
      id: 'sellar-perfil',
      titulo: 'Sellar tu perfil al terminar el paso 3',
      como: 'En el último paso, el botón «Sellar perfil» abre un cuadro de confirmación («¿Sellar su perfil sociodemográfico?»); al confirmar, tu perfil queda de solo lectura y aparece en tu historial de versiones.',
      porQueImporta:
        'Sellar es la manera en que tu perfil queda oficialmente registrado para el período vigente, y es lo que cierra tu registro: ahí aparece «Ir a mi espacio» y Kairos deja de pedírtelo. Antes de sellar puedes seguir editando libremente; después, si tu empresa necesita una actualización, te la vuelve a solicitar y ahí se abre una versión nueva.',
    },
  ],
}
